import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'shared/shared.module';

import { SidebarComponent } from './sidebar.component';

const modules = [RouterModule, SharedModule];

@NgModule({
    imports: modules,
    declarations: [SidebarComponent],
    exports: [SidebarComponent]
})
export class SidebarModule {}
